import { render } from "./SearchFilterContainer.vue?vue&type=template&id=5662fc8d"
const script = {}

import "./SearchFilterContainer.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__